import { PATHS } from '@ctcells/core'
import { t } from '@ctcells/i18n'
import { useNavigate, useParams } from 'react-router'

import { cx } from '../atoms/cx.ts'
import { ModuleDetailContainer, ModulesContainer } from '../screens/modules/ModulesContainer.tsx'

/**
 * 관리 › 모듈의 **목록 + 오른쪽 상세 판**(eric 2026-09-22 「관리에서 모듈과 사용자 부분도 해당 row 를
 * 클릭하면 상세 페이지 내용이 보이게」). 준비 3종(`consoleResourceViews.tsx`)과 같은 뼈대다.
 *
 * - 주소는 종전 그대로(`/modules` · `/modules/:moduleId`)다. 새로고침 · 뒤로가기 · 감사 이력의 링크가 다 산다
 * - 목록은 늘 서고(관리 탭 줄 포함), `:moduleId` 가 있으면 오른쪽 판이 열린다. 다른 행을 누르면 판의
 *   내용만 바뀐다(`key` 로 판을 새로 세워 밀려 들어오는 움직임이 다시 난다)
 * - 🔴 상세는 **같은 컨테이너**다. 판에 맞춰 두 벌을 만들지 않는다 — 장비 관점 콘솔은 그 컨테이너를
 *   prop 없이 전체 화면으로 쓴다(그래서 `onClose` 는 옵션이다)
 * - ⚠ 보정 상세 라우트는 통합 콘솔에 없다(2026-10-22 · 모듈 상세 「보정」 탭을 걷으며 같이 걷었다 · `consoleResourceRoutes.tsx`)
 *
 * 라우트 표(`consoleResourceRoutes.tsx`)와 파일을 나눈 것은 한 파일이 컴포넌트만 내보내야 핫리로드가 성립해서다.
 */
export function ModulesSplitRoute() {
  const navigate = useNavigate()
  const { moduleId } = useParams()
  return (
    <div className={cx('splitpage', moduleId !== undefined && 'splitpage--open')}>
      <ModulesContainer adminTab="modules" selectedModuleId={moduleId} />
      {moduleId === undefined ? null : (
        <aside
          aria-label={t('screen.moduleDetail.title')}
          className="splitpage__pane"
          key={moduleId}
        >
          <ModuleDetailContainer onClose={() => void navigate(PATHS.modules)} />
        </aside>
      )}
    </div>
  )
}
